import { useMediaQuery } from './useMediaQuery';

function useIsMobile() {
    return useMediaQuery('(max-width: 767px)');
}

export { useIsMobile };
